<app-top-nav />

<nav class="navbar navbar-expand-lg top-navbar">
    <div class="container">
        <!-- Logo -->
        <a class="navbar-brand" routerLink="/home" routerLinkActive="active">
            <img loading="lazy" src="images/dspace-logo.svg" alt="Maeen Library Management" class="logo-img">
        </a>

        <!-- Mobile Toggle -->
        <button class="navbar-toggler shadow-none border-0" type="button" (click)="toggleMenu()"
            aria-controls="navbarSupportedContent" [attr.aria-expanded]="!(menuCollapsed | async)"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Navbar -->
        <div class="collapse navbar-collapse justify-content-between" [class.show]="!(menuCollapsed | async)" id="navbarSupportedContent">

            <!-- Main Menu -->
            <ul class="navbar-nav d-flex align-items-center">

                <li class="nav-item">
                    <a class="nav-link " routerLink="/home" routerLinkActive="active">

                        {{"Nav.Home" | translate}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/libraries" routerLinkActive="active">
                        {{"Nav.libraries" | translate}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/browse-index" routerLinkActive="active">

                        {{"Nav.biblios" | translate}}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" routerLink="/news" routerLinkActive="active">
                        {{"Nav.quranSciences" | translate}}
                    </a>
                </li>
                


                <li class="nav-item">
                    <a class="nav-link" href="https://kawla.gov.sa/about-complex/help/contact-us">
                        {{"Nav.contactUs" | translate}}
                    </a>
                </li>

            </ul>

            <!-- Actions -->
            <ul class="navbar-nav d-flex align-items-center gap-1">
                <!-- Search -->
                <li class="nav-item">
                    <a class="item-action" (click)="showSearch.set(true)" routerLinkActive="active">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11 1.25C5.61522 1.25 1.25 5.61522 1.25 11C1.25 16.3848 5.61522 20.75 11 20.75C13.4224 20.75 15.6385 19.8666 17.3437 18.4043L21.4697 22.5303C21.7626 22.8232 22.2374 22.8232 22.5303 22.5303C22.8232 22.2374 22.8232 21.7626 22.5303 21.4697L18.4043 17.3437C19.8666 15.6385 20.75 13.4224 20.75 11C20.75 5.61522 16.3848 1.25 11 1.25ZM2.75 11C2.75 6.44365 6.44365 2.75 11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 15.5563 15.5563 19.25 11 19.25C6.44365 19.25 2.75 15.5563 2.75 11Z"
                                fill="#161616"></path>
                        </svg>

                    </a>
                </li>

                <!-- Language -->
                <li class="nav-item" (click)="changeLanguage()">
                    <a class="item-action">
                        <img loading="lazy" src="/images/custom/lang.svg" alt="language">
                    </a>
                </li>

            </ul>
        </div>
    </div>
</nav>

@if (showSearch()) {
<div class="search-wrapper">
    <div class="container">
        <div class="search__container position-relative">
            <div class="Button-wrapper d-flex justify-content-end">
                <button (click)="showSearch.set(false)" class="btn-close-search shadow-none p-0" type="button">
                    <img loading="lazy" src="images/custom/close-btn.svg" style="width: 12px; height: 12px"
                        alt="Close" />
                </button>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-4 mt-40">
                <app-search-inp (search)="onSearch($event)"></app-search-inp>
            </div>
            <div class="suggestions mt-4">
                <!-- <h6 class="mb-3">{{ "suggestions" | translate }}</h6> -->
                <!-- <div class="d-flex flex-wrap gap-2"> -->
                <!-- <button class="btn_secondary" (click)="
                onTranslatedSearch(
                  translate.currentLang === 'en'
                    ? modelsName.quranEN
                    : modelsName.quranAR
                )
              ">
            + {{ "quran" | translate }}
          </button>
          <button class="btn_secondary" (click)="
                onTranslatedSearch(
                  translate.currentLang === 'en'
                    ? modelsName.bookEN
                    : modelsName.bookAR
                )
              ">
            + {{ "book" | translate }}
          </button>
          <button class="btn_secondary" (click)="
                onTranslatedSearch(
                  translate.currentLang === 'en'
                    ? modelsName.manuscriptEN
                    : modelsName.manuscriptAR
                )
              ">
            + {{ "menuscript" | translate }}
          </button> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>
}